bq.payInvoice = function(element, options) {
    this.options   = options;
    this.eventsCreated = false;
    this.$element  = $(element);
    this.$wrapper  = false;
    this.$addInvoicesButton = false;
    this.$listingContainer = false;
    this.$actionButtons = false;
    this.gridsUpdated = 0;
    this.processingGrids = 0;
    this.keepInvoicesChecked = true;
    this.pendingLeaveUrl = '';
    this.hasBatchItems = false;
    this._nativeNavigateAwayHandler = null;
    this.leaveGuard = null;
};

bq.payInvoice.DEFAULTS = {
    wrapper: '.invoices-grid-wrapper',
    selectedInvoicesContainer: '.selected-invoices-container',
    actionButtons: '.batch-container-buttons',
    submitBatchForm: '#bqat-frmSubmitBatch',
    listingContainer: '.listing-container',
    addInvoicesButton: '[data-action-add=""]',
    addInvoicesCheckbox: '[name="add_invoice[]"], [name="add_invoice"]',
    addInvoicesTopCheckbox: '[name="add_invoice"]',
    checkedInvoicesSelector: '[name="add_invoice[]"]:checked'
};

bq.payInvoice.prototype = {
    init: function() {
        bq.debug.log("Pay Invoice : init()", this.$element);
        this.$wrapper = $(this.options.wrapper);
        this.$addInvoicesButton = $(this.options.addInvoicesButton);
        this.$addInvoicesTopCheckbox = $(this.options.addInvoicesTopCheckbox);
        this.$listingContainer = $(this.options.listingContainer);
        this.$selectedInvoicesContainer = $(this.options.selectedInvoicesContainer);
        this.$actionButtons = $(this.options.actionButtons);
        this.hasBatchItems = !this.$actionButtons.hasClass('hide');
        if(!this.eventsCreated) {
            this.$element.on('click', '[data-action-remove-all], [data-action-remove], [data-action-add]', {context:this}, this._catchDataActionEvent);
            this.$element.on('change', this.options.addInvoicesCheckbox, {context:this}, this._catchCheckboxChangeAction);
            this.$element.on('keydown', '[name*=net_amount]', {context:this}, this._catchNetAmountEvent);
            this.$listingContainer.on('bq.itemListing.loadStart', {context: this}, this._countUpdatedGrids);
            this.$listingContainer.on('bq.itemListing.loadEnd', {context: this}, this._catchGridUpdate);
            this.$listingContainer.on('bq.pagination.changed', {context: this}, this._catchPaginationChanged);
            $(document).on('click.bqPayInvoicesLeaveGuard', 'a[href]', {context: this}, this._catchNavigateAwayEvent);
            if (this._isNewDesign()) {
                if (bq && bq.LeaveConfirmGuard) {
                    this.leaveGuard = new bq.LeaveConfirmGuard({
                        isEnabled: true,
                        getIsDirty: () => this.hasBatchItems,
                        getIsBlocked: () => true,
                        getPendingUrl: () => this.pendingLeaveUrl,
                        setPendingUrl: (url) => { this.pendingLeaveUrl = url; },
                        modalId: 'pay_invoices_leave_confirmation',
                        confirmSelector: "[data-pay-leave-confirm='1']",
                        confirmDataAttr: "data-pay-leave-confirm",
                        shouldIgnoreHref: (href, link) => {
                            if (!link) return false;
                            if (href.indexOf("checkout/cart") !== -1 || href.indexOf("checkoutlite/cart") !== -1) return true;
                            if ($(link).is('[data-action-add], [data-action-remove], [data-action-remove-all], [data-show-loading-modal]')) return true;
                            return false;
                        },
                        onBeforeNavigate: () => {
                            bq.helper.throwEvent('bq.viewhandler.progressmessage', $('body'), {
                                message: bq.messages.global.loadingLongWait
                            });
                        }
                    });
                    this.leaveGuard.mount();
                } else {
                    // Fallback for pages that don't load React/shared guard bundle.
                    this._nativeNavigateAwayHandler = this._catchNavigateAwayCaptureEvent.bind(this);
                    document.addEventListener('click', this._nativeNavigateAwayHandler, true);
                }
            }
            this.eventsCreated = true;
            $(this.options.submitBatchForm).on('submit', {context: this}, this._catchSubmitForm);
            $(window).on('load', {context: this}, this._catchWindowLoad);
        }

        this.keepInvoicesChecked = this.$listingContainer.data('keepInvoicesChecked');
        this._updateGrids = this._updateGrids.bind(this);
        this._successCallback = this._successCallback.bind(this);
        this._errorCallback = this._errorCallback.bind(this);
        this._catchCheckboxChangeAction = this._catchCheckboxChangeAction.bind(this);
    },

    destroy: function() {
        if (this.leaveGuard) {
            this.leaveGuard.unmount();
            this.leaveGuard = null;
        }
        if (this._nativeNavigateAwayHandler) {
            document.removeEventListener('click', this._nativeNavigateAwayHandler, true);
            this._nativeNavigateAwayHandler = null;
        }
    },

    _handleBeforeUnload: function (e) {
        e.preventDefault();
        e.returnValue = '';
    },

    _processRemove: function(element) {
        this.request(element.attr('href'), {}, this._successCallback, this._errorCallback);
    },

    _processRemoveAll: function(element) {
        this.request(element.data('url'), {}, this._successCallback, this._errorCallback);
    },

    _processInvoices: function(element) {
        var invoices = this._getSelectedInvoices();
        var data = {'selected_invoices': invoices};
        this.request(element.data('url'), data, this._successCallback, this._errorCallback);
    },

    _countUpdatedGrids: function(e) {
        var $this = e.data.context;
        $this.processingGrids++;
    },

    _catchGridUpdate: function(e) {

        var $this = e.data.context;
        $this.gridsUpdated++;
        if ($this.processingGrids === $this.gridsUpdated) {
            $this._throwEventLoadEnd();
            $this.gridsUpdated = 0;
            $this.processingGrids = 0;
        } else {
            $this._throwEventLoadStart();
        }
    },

    _catchPaginationChanged: function(e) {
        var $this = e.data.context;
        if ($this.keepInvoicesChecked) {
            return;
        }

        $($this.options.addInvoicesCheckbox).each(function() {
            var $el = $(this);
            $el.prop('checked', false);
        });
    },

    _updateGrids: function() {
        this.$addInvoicesButton.prop('disabled', true);
        $(this.options.listingContainer).each(function() {
            var $el = $(this);
            $el.triggerHandler('bq.grid.changed');
        });
    },

    _catchDataActionEvent: function(e) {
        e.preventDefault();
        var $this = e.data.context,
            $el = $(e.currentTarget);

        $this._throwEventLoadStart();

        if ($el.data('actionRemove') === '') {
            $this._processRemove($el);
        } else if($el.data('actionRemoveAll') === '') {
            $this._processRemoveAll($el);
        } else if($el.data('actionAdd') === '') {
            $this._processInvoices($el);
        }
    },

    _catchWindowLoad: function(e) {
        var $this = e.data.context;
        if (!$this._isNewDesign()) {
            window.addEventListener('beforeunload', $this._handleBeforeUnload);
        }
        $this.$addInvoicesButton.prop('disabled', !$this._getSelectedInvoices().length);
    },

    _catchSubmitForm: function(e) {
        var $this = e.data.context;
        var $activeElement = $(document.activeElement);
        e.preventDefault();
        if ($activeElement.is('[data-show-loading-modal]') && $this._isNewDesign()) {
            bq.helper.throwEvent('bq.viewhandler.progressmessage', $('body'), {
                message: bq.messages.global.loadingLongWait
            });
        }
        window.removeEventListener("beforeunload", $this._handleBeforeUnload);
        this.submit();
    },

    _isNewDesign: function() {
        return bq.getIsThemeNew();
    },

    _catchNetAmountEvent: function(e) {
        var key = e.charCode || e.keyCode || 0;
        // allow to enter only digits and decimals
        return (
            key == 8 ||
            key == 9 ||
            key == 13 ||
            key == 46 ||
            key == 110 ||
            key == 190 ||
            (key >= 35 && key <= 40) ||
            (key >= 48 && key <= 57) ||
            (key >= 96 && key <= 105));
    },

    request: function(url, data, successCallback, errorCallback) {
        $.ajax({
            type: 'post',
            url: url,
            data: data,
            success: function (response) {
                var json = JSON.parse(response);

                if (json['redirect']) {
                    window.removeEventListener("beforeunload", this._handleBeforeUnload);
                    window.location.href = json['redirect'];
                    return;
                }

                if (json['error'] === true) {
                    errorCallback(json['message']);
                } else {
                    successCallback(json['message'], json['hasItems']);
                }

            }.bind(this)
        });
    },

    _throwEventLoadStart: function() {
        bq.helper.throwEvent('bq.viewhandler.start', this.$wrapper)
    },

    _throwEventLoadEnd: function() {
        bq.helper.throwEvent('bq.viewhandler.stop', this.$wrapper)
    },

    _successCallback: function(message, hasItems) {
        if (typeof hasItems === 'undefined') {
            hasItems = false;
        }
        this.hasBatchItems = !!hasItems;

        if (hasItems) {
            this.$actionButtons.removeClass('hide');
            this.$selectedInvoicesContainer.find('thead .headings').removeClass('hide');
        } else {
            this.$actionButtons.addClass('hide');
            this.$selectedInvoicesContainer.find('thead .headings').addClass('hide');
        }

        this._updateGrids();
        this.$addInvoicesTopCheckbox.prop('checked', false);
        this._catchSuccessMessage(message);
    },

    _errorCallback: function(message) {
        this._catchErrorMessage(message);
        this._throwEventLoadEnd();
    },

    _catchErrorMessage: function(message) {
        bq.helper.throwEvent('bq.notification', $(document), {
            id: 'notification_bq-ui-invoices-batch',
            text: message,
            type: 'error'
        });
    },

    _catchCheckboxChangeAction: function(e) {
        var $this = e.data.context;
        var hasSelectedInvoices = $this._getSelectedInvoices().length > 0;
        $this.$addInvoicesButton.prop('disabled', !hasSelectedInvoices);
    },

    _catchSuccessMessage: function(message) {
        bq.helper.throwEvent('bq.notification', $(document), {
            id: 'notification_bq-ui-invoices-batch',
            text: message,
            type: 'success'
        });
    },

    _getSelectedInvoices: function() {
        return $(this.options.checkedInvoicesSelector).map(function (_,el) {
            return el.value;
        }).get();
    },

    _catchNavigateAwayEvent: function(e) {
        // Capture-phase handler is the source of truth for new design.
        if (e.data.context._isNewDesign()) {
            return;
        }
        var $this = e.data.context;
        var $target = $(e.currentTarget);
        if (!$this._shouldInterceptNavigateAway($target, e)) {
            return;
        }

        e.preventDefault();
        $this.pendingLeaveUrl = $target.attr('href') || '';
        $this._showLeaveConfirmModal();
    },

    _catchNavigateAwayCaptureEvent: function(e) {
        // New design uses LeaveConfirmGuard; this handler is no longer used.
        if (this.leaveGuard) {
            return;
        }
        var $target = $(e.target).closest('a[href]');
        if (!$target.length) {
            return;
        }
        if (!this._shouldInterceptNavigateAway($target, e)) {
            return;
        }

        e.preventDefault();
        if (typeof e.stopImmediatePropagation === 'function') {
            e.stopImmediatePropagation();
        }
        e.stopPropagation();
        this.pendingLeaveUrl = $target.attr('href') || '';
        this._showLeaveConfirmModal();
    },

    _shouldInterceptNavigateAway: function($target, e) {
        var href = $target.attr('href') || '';
        if (!this._isNewDesign() || !this.hasBatchItems) {
            return false;
        }
        // Header "Shopping Cart" should never trigger leave modal.
        if (href.indexOf('checkout/cart') !== -1 || href.indexOf('checkoutlite/cart') !== -1) {
            return false;
        }
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.which === 2) {
            return false;
        }
        if (
            !href ||
            href === '#' ||
            href.indexOf('javascript:') === 0 ||
            href.indexOf('mailto:') === 0 ||
            href.indexOf('tel:') === 0 ||
            $target.attr('target') === '_blank' ||
            typeof $target.attr('download') !== 'undefined' ||
            $target.closest('.modal').length ||
            $target.is('[data-bq="popup"], [data-bq="popup-static"], [data-bq="collapse"], [data-toggle="modal"], [data-toggle="collapse"], [data-content-target]') ||
            $target.is('[data-action-add], [data-action-remove], [data-action-remove-all], [data-show-loading-modal]')
        ) {
            return false;
        }
        return true;
    },

    _showLeaveConfirmModal: function() {
        var modalId = 'pay_invoices_leave_confirmation';
        var footer = '' +
            '<button type="button" class="btn btn-default" data-dismiss="modal">' + bq.messages.global.dialogCancel + '</button>' +
            '<button type="button" class="btn btn-primary" data-pay-leave-confirm="1">' + (bq.messages.global.leave || 'Leave') + '</button>';

        if (!bq.helper.modal.modals[modalId]) {
            bq.helper.modal.create(
                modalId,
                false,
                'Leave site?',
                'Changes that you made may not be saved.',
                footer,
                {}
            );
            bq.helper.modal.modals[modalId].on('click', '[data-pay-leave-confirm="1"]', {context: this}, function(e) {
                var $this = e.data.context;
                var nextUrl = $this.pendingLeaveUrl;
                if (nextUrl) {
                    bq.helper.modal.modals[modalId].modal('hide');
                    bq.helper.throwEvent('bq.viewhandler.progressmessage', $('body'), {
                        message: bq.messages.global.loadingLongWait
                    });
                    window.removeEventListener('beforeunload', $this._handleBeforeUnload);
                    setTimeout(function() {
                        window.location.href = nextUrl;
                    }, 0);
                }
            });
        }

        bq.helper.modal.modals[modalId].modal('show');
    },

    _syncBeforeUnloadGuard: function() {
        if (!this._isNewDesign()) {
            return;
        }
        window.removeEventListener('beforeunload', this._handleBeforeUnload);
        if (this.hasBatchItems) {
            window.addEventListener('beforeunload', this._handleBeforeUnload);
        }
    }
};

// PAY INVOICES PLUGIN DEFINITION
// =======================

var payInvoiceOld = $.fn.payInvoice;

$.fn.payInvoice = function (option, _relatedTarget) {
    return this.each(function () {
        var $this   = $(this);
        var data    = $this.data('bq.payInvoice');
        var options = $.extend({}, bq.payInvoice.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

        if (!data) { $this.data('bq.payInvoice', (data = new bq.payInvoice(this, options))); }
        data.init();
    });
};

$.fn.payInvoice.Constructor = bq.payInvoice;

// PAY INVOICES NO CONFLICT
// =================

$.fn.payInvoice().noConflict = function () {
    $.fn.payInvoice = payInvoiceOld();
    return this;
};

// PAY INVOICES DATA-API
// ==============

bq.payInvoicesInit = function() {
    $('[data-bq="payInvoices"]').each(function () {
        var $el = $(this);
        $el.payInvoice($el.data());
    });
};

bq.init.push(bq.payInvoicesInit);